import { useAuth0 } from "ct-auth"
import { entitlementTypes, isManager, userHasEntitlement, userOrg } from "../data-utils/authUtils"
import { useQueries } from "../data-utils/reactQueryHelpers"

// Whether the signed-in user holds the INTEGRATIONS entitlement — the gate for every integrations
// surface (Integration Hub nav + route, the reports' "Create ticket"). Same rule as the side panel
// and the server (integrations-handlers.js hasIntegrationsEntitlement): managers always; sponsors and
// trainers only when their org is granted it. During a role assumption the assumed org is checked
// (userOrg / isManager follow the assumption).
//
// `loading` is true only while a customer's org is still being read, so callers can wait instead of
// flashing "no access". The org read is the app-wide cached HOME_USER_ORG query (the side panel
// already makes it); a manager needs no org read.
export const useIntegrationsEntitlement = () => {
  const { user } = useAuth0()
  const manager = isManager(user)
  const orgId = userOrg(user)
  const { data: org, isError } = useQueries.HOME_USER_ORG({ orgId, enabled: !manager && Boolean(orgId) })
  const entitled = userHasEntitlement({ user, org, entitlementType: entitlementTypes.INTEGRATIONS })
  const loading = !entitled && !manager && Boolean(user?.sub && orgId) && org === undefined && !isError
  return { entitled, loading }
}
